/** @jsxImportSource @emotion/react */
import React from 'react'
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import Text from 'src/components/ts-components/Text'

interface ProfileMenuItemProps {
  icon: React.ReactNode
  label: string
  onClick?: () => void
  textColor?: string
}

const ProfileMenuItem = ({
  icon,
  label,
  onClick,
  textColor = colors.NEUTRAL_0,
}: ProfileMenuItemProps) => {
  return (
    <div
      onClick={
        onClick
          ? (e) => {
              e.preventDefault()
              onClick()
            }
          : undefined
      }
      css={css`
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 8px;
        transition: all 0.2s ease-in-out;
        &:hover {
          color: ${colors.PRIMARY};
        }
      `}
    >
      {icon}
      <Text variant='paragraphSmall' weight='regular' color={textColor}>
        {label}
      </Text>
    </div>
  )
}

export default ProfileMenuItem
